import styled from '@emotion/styled';
import colors from '../styles/colors';

export const TitleHeader4 = styled.h4`
  font-family: Anton;
  letter-spacing: 1px;
  color: ${colors.almostBlack};
  margin-bottom: 20px;
`;
